// src/ids.ts
var asCustomerId = (s) => s;
var asContactId = (s) => s;
var asThreadId = (s) => s;
var asTaskId = (s) => s;
var asProjectId = (s) => s;

// src/helpers.ts
function readString(value) {
  return typeof value === "string" && value.length > 0 ? value : void 0;
}
async function customer(id, supabase) {
  const { data, error } = await supabase.from("companies").select(
    "id, name, primary_email, domain, stripe_customer_id, hubspot_id, created_at"
  ).eq("id", id).maybeSingle();
  if (error) throw error;
  if (!data) return null;
  return {
    id: asCustomerId(data.id),
    name: data.name,
    email: readString(data.primary_email),
    domain: readString(data.domain),
    stripeCustomerId: readString(data.stripe_customer_id),
    hubspotId: readString(data.hubspot_id),
    createdAt: data.created_at
  };
}
async function threadsForCustomer(id, supabase, opts = {}) {
  const limit = opts.limit ?? 20;
  const { data, error } = await supabase.from("threads").select(
    "id, subject, participants, last_message_at, unread, omni_customer_id"
  ).eq("omni_customer_id", id).order("last_message_at", { ascending: false }).limit(limit);
  if (error) throw error;
  return (data ?? []).map((row) => ({
    id: asThreadId(row.id),
    subject: row.subject ?? "",
    participants: Array.isArray(row.participants) ? row.participants : [],
    lastMessageAt: row.last_message_at,
    unread: row.unread ?? void 0,
    customerId: row.omni_customer_id ? asCustomerId(row.omni_customer_id) : void 0
  }));
}
async function tasksForCustomer(id, supabase, opts = {}) {
  const limit = opts.limit ?? 20;
  let query = supabase.from("tasks").select(
    "id, title, status, project_id, customer_id, due_at, priority"
  ).eq("customer_id", id);
  if (!opts.includeDone) {
    query = query.neq("status", "done");
  }
  const { data, error } = await query.order("due_at", { ascending: true }).limit(limit);
  if (error) throw error;
  return (data ?? []).map((row) => ({
    id: asTaskId(row.id),
    title: row.title ?? "",
    status: row.status,
    projectId: row.project_id ? asProjectId(row.project_id) : void 0,
    customerId: row.customer_id ? asCustomerId(row.customer_id) : void 0,
    dueAt: row.due_at ?? void 0,
    priority: row.priority ?? void 0
  }));
}
async function projectsForCustomer(id, supabase, opts = {}) {
  let query = supabase.from("projects").select("id, name, customer_id, status, cadence").eq("customer_id", id);
  if (!opts.includeArchived) {
    query = query.neq("status", "archived");
  }
  const { data, error } = await query.order("name");
  if (error) throw error;
  return (data ?? []).map((row) => ({
    id: asProjectId(row.id),
    name: row.name ?? "",
    customerId: row.customer_id ? asCustomerId(row.customer_id) : void 0,
    status: row.status,
    cadence: row.cadence ?? void 0
  }));
}

export { asContactId, asCustomerId, asProjectId, asTaskId, asThreadId, customer, projectsForCustomer, tasksForCustomer, threadsForCustomer };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map